import { RouteConstants } from "../constants";
import IRoute from "../models/route.interface";
import { filterRoutesByAppScopes } from "../utils/routes.util";
import useAppScopes from "./useAppScopes";

export default function useScopedRoutes(routes: IRoute[]) {
  const {
    scopes,
    scopesState: { uniqueIdActive },
  } = useAppScopes();

  let defaultRedirectUrl = uniqueIdActive ? RouteConstants.ECGS_PATH : undefined;

  return {
    routes: filterRoutesByAppScopes(routes, scopes),
    defaultRedirectUrl,
  };
}
